import PropTypes from 'prop-types';
export const buttonGuidePropTypes = {
  /**
   * Label
   */
  label: PropTypes.string,
  /**
   * OnClick function
   */
  onClick: PropTypes.func
};